export class SubCategory{

  public static getProperSubcategoryName(name: string): string {
      return name === 'csc_recommendations' ? 'Miscellaneous' : name.replace(/^[a-z]+_/, '').replace(/_/g, ' ');
  }

}
